import Utils from '../Utils';
import { BASE_URL } from '../Config';
import AxiosInstance from '../AxiosInstance';

const PATH = 'methodology/';

const Get = (params) => {
  const url = BASE_URL + 'methodology' + Utils.ObjectToParams(params);
  return AxiosInstance.get(url);
};

const GetInfo = () => {
  const url = BASE_URL + PATH + 'info';
  return AxiosInstance.get(url);
};

const GetDetail = (seq) => {
  const url = BASE_URL + PATH + seq;
  return AxiosInstance.get(url);
};

const Post = (body) => {
  const url = BASE_URL + 'methodology';
  return AxiosInstance.post(url, body);
};

const Put = (seq, body) => {
  const url = BASE_URL + PATH + seq;
  return AxiosInstance.put(url, body);
};

const PutUpdate = (seq, body) => {
  const url = BASE_URL + PATH + seq + '/update';
  return AxiosInstance.put(url, body);
};

const PutRevokeApproval = (seq) => {
  const url = BASE_URL + PATH + seq + '/revoke-approval';
  return AxiosInstance.put(url);
};

const GetHistoryList = (seq, params) => {
  const url = BASE_URL + PATH + seq + '/history' + Utils.ObjectToParams(params);
  return AxiosInstance.get(url);
};

// ITS-200. 관련 문서(등록부·공개논평 draft) CRUD.
const GetDocuments = (seq) => {
  const url = BASE_URL + PATH + seq + '/documents';
  return AxiosInstance.get(url);
};

const PostDocument = (seq, body) => {
  const url = BASE_URL + PATH + seq + '/documents';
  return AxiosInstance.post(url, body);
};

const DeleteDocument = (seq, docSeq) => {
  const url = BASE_URL + PATH + seq + '/documents/' + docSeq;
  return AxiosInstance.delete(url);
};

// ITS-200. 공개논평 개설.
const PostConsultation = (seq, body) => {
  const url = BASE_URL + PATH + seq + '/consultation';
  return AxiosInstance.post(url, body);
};

// ITS-200. 등록부 공개 토글.
const PatchRegistryVisibility = (seq, body) => {
  const url = BASE_URL + PATH + seq + '/registry-visibility';
  return AxiosInstance.patch(url, body);
};

const Methodology = {
  Get: Get,
  GetInfo: GetInfo,
  GetDetail: GetDetail,
  Post: Post,
  Put: Put,
  PutUpdate: PutUpdate,
  PutRevokeApproval: PutRevokeApproval,
  GetHistoryList: GetHistoryList,
  GetDocuments: GetDocuments,
  PostDocument: PostDocument,
  DeleteDocument: DeleteDocument,
  PostConsultation: PostConsultation,
  PatchRegistryVisibility: PatchRegistryVisibility,
};

export default Methodology;
